import * as React from 'react';
import { SVGProps, memo } from 'react';

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
const SvgCrown = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#F8E71C"
      fillRule="evenodd"
      d="M4.823 17A45.053 45.053 0 0 0 3 7.584l4.758 3.554L12 5l4.242 6.138L21 7.584A44.99 44.99 0 0 0 19.177 17c-4.324-.007-10.03-.007-14.354 0z"
      clipRule="evenodd"
    />
  </svg>
);
const Memo = memo(SvgCrown);
export default Memo;
